import axios from 'axios'

export const api = axios.create({
  timeout: 60000 * 3,
  baseURL: `${process.env.API_BASE_URL}/api`,
  withCredentials: true,
})
